import React, { useState } from "react";
import { toast } from "sonner";
import { GraduationCap, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export const PortfolioPassButton = ({ u, onDone }) => {
  const [busy, setBusy] = useState(false);
  const passed = Boolean(u.portfolio_passed_at);
  const toggle = async () => {
    if (!window.confirm(passed ? `Remove the Executive Integration Portfolio pass for ${u.name}?` : `Mark ${u.name}'s Executive Integration Portfolio as passed (15 GCSB Academic Credits)?`)) return;
    setBusy(true);
    try { await api.post(`/admin/users/${u.id}/portfolio`, { passed: !passed }); toast.success(passed ? "Portfolio pass removed" : "Portfolio marked as passed"); onDone?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={toggle} disabled={busy} className={`chip inline-flex items-center gap-1 text-xs disabled:opacity-50 ${passed ? "border-emerald-300 bg-emerald-50 text-emerald-800" : ""}`} data-testid={`portfolio-pass-${u.id}`}>
      <GraduationCap size={12}/> {passed ? "Portfolio passed" : "Mark portfolio passed"}
    </button>
  );
};

export const PortfolioInviteButton = ({ u, onDone }) => {
  const [busy, setBusy] = useState(false);
  const sent = u.portfolio_invited_at;
  const invite = async () => {
    if (!window.confirm(`${sent ? "Resend" : "Send"} the Executive Integration Portfolio invitation to ${u.name} (${u.email})?`)) return;
    setBusy(true);
    try { await api.post(`/admin/users/${u.id}/portfolio-invite`); toast.success(`Portfolio invitation sent to ${u.email}`); onDone?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={invite} disabled={busy} className="chip inline-flex items-center gap-1 text-xs disabled:opacity-50" data-testid={`portfolio-invite-${u.id}`}>
      <Send size={12}/> {sent ? `Portfolio invited ${new Date(sent).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })}` : "Invite to portfolio"}
    </button>
  );
};
